let weixin = {
    path: "weixin",
    name: "weixin",
    component: () => import("@/views/weixin/index.vue"),
    meta: {
        name: "应用",
    },
    children: [{
            path: "pageManage/list",
            name: "pageManageList",
            component: () => import("@/views/weixin/pageManage/list.vue"),
            meta: {
                name: "页面设置列表",
            },
        },
      
    ],
};

export default weixin;